import { render, staticRenderFns } from "./search_details.vue?vue&type=template&id=df0fe4ae&scoped=true"
import script from "./search_details.vue?vue&type=script&lang=js"
export * from "./search_details.vue?vue&type=script&lang=js"
import style0 from "./search_details.vue?vue&type=style&index=0&id=df0fe4ae&prod&lang=less"
import style1 from "./search_details.vue?vue&type=style&index=1&id=df0fe4ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0fe4ae",
  null
  
)

export default component.exports